import {
  usePaginatedResource,
  useResourceItem,
  useCreateResource,
  useDeleteResource,
} from "./useCrudResource"
import {
  getAccountLoanRepayments,
  getAccountLoanRepayment,
  createAccountLoanRepayment,
  deleteAccountLoanRepayment,
} from "api/accountLoanRepaymentApi"

export const ACCOUNT_LOAN_REPAYMENT_QUERY_KEY = "account-loan-repayments"

export const useAccountLoanRepayments = (params = {}, enabled = true) => {
  return usePaginatedResource(
    ACCOUNT_LOAN_REPAYMENT_QUERY_KEY,
    getAccountLoanRepayments,
    params,
    enabled
  )
}

export const useAccountLoanRepayment = (id, enabled = true) => {
  return useResourceItem(
    ACCOUNT_LOAN_REPAYMENT_QUERY_KEY,
    getAccountLoanRepayment,
    id,
    enabled
  )
}

export const useCreateAccountLoanRepayment = () => {
  return useCreateResource(
    createAccountLoanRepayment,
    ACCOUNT_LOAN_REPAYMENT_QUERY_KEY
  )
}

export const useDeleteAccountLoanRepayment = () => {
  return useDeleteResource(
    deleteAccountLoanRepayment,
    ACCOUNT_LOAN_REPAYMENT_QUERY_KEY
  )
}
